import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import {IconClose, IconSearchPdfCard} from "../../Icon";
import {Dropdown, Input, type MenuProps, message, Modal} from "antd";
import {t} from "i18next";
import {getTagList, removeTag, updateTag} from "@model/tag";
import {generateRandomPageKey, imgPathPerfix, isDarkMode, isStringNullOrEmpty} from "@/utils";
import Global from "@/global";
import {openEditor} from "@/state";
import DialogCommonInput from "@/common/DialogCommonInput";
import DialogMessageBox from "@/common/DialogMessageBox";
import {removeAllCardTags} from "@model/card";

let mArrayAllDatas:any;
let mSelectTag:any;

const DialogAllTagManager = forwardRef((props:{onDismissCallback:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }));
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [searchKey,setSearchKey] = useState('');
    const [arrayDatas,setArrayDatas] = useState([]);
    const dialogInputRef = useRef(null);

    const [menuItems,setMenuItems] = useState<MenuProps['items']>([{
        label: t("Edit"),
        key: 'edit',
        icon: null,//<IconRename/>
    },
        {
            label: t("Delete"),
            key: 'delete',
            icon: null,//<IconRename/>
        }]);

    const onShowDialog = ()=>{
        setIsShowDialog(true);
        setSearchKey('');
        refreshTagList();
    }

    const refreshTagList=()=>{
        getTagList().then(res=>{
            mArrayAllDatas = res;
            setArrayDatas(res);
        })
    }

    /**
     * 右键菜单，转到上级去处理
     * @param e
     */
    const handleMenuClick = async (e: any) => {
        if (e.key == 'edit'){
            onEditTag(mSelectTag);
        }else if (e.key == 'delete'){
            window.showMessageBox(t("Delete tag"),t("ConfirmDeleteTag"),t("Cancel"),t("Confirm"),null,()=>{
                removeTag(mSelectTag?.id).then(res=>{
                    refreshTagList();
                });

                removeAllCardTags(mSelectTag?.name);
            })
        }
    }

    const onEditTag = (tag:any)=>{
        dialogInputRef.current?.onShowDialogAll(tag?.name??'',t("Edit tag"),t("Cancel"),t("Save"),(szContent:any)=>{
            //标签名称是否存在
            const arrayFilters = mArrayAllDatas?.filter(p=>p.name.toLowerCase() == szContent.toLowerCase());
            let bExist = false;
            if (tag){
                if (arrayFilters.length > 0){
                    if (arrayFilters[0].id != tag.id){
                        bExist = true;
                    }
                }else{
                    bExist = arrayFilters.length > 0;
                }
            }
            if (bExist){
                message.info(t("Tag exist"));
                return;
            }
            dialogInputRef.current?.onCloseDialog();

            //添加...
            updateTag({
                name:szContent
            }).then(res=>{
                refreshTagList();
            })
        })
    }

    return (
        <Modal width={768} bodyStyle={{minHeight: '530px'}} open={isShowDialog} centered={true} closable={true}
               closeIcon={<IconClose/>} footer={''} onCancel={() => {
            setIsShowDialog(false);
            props.onDismissCallback();
        }}>
            <div>
                <span className={'dialog-title'}>{t("Manage tags")}</span>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>
                <div className={'flex-row-vertical-center'}>
                    <Input prefix={<IconSearchPdfCard/>}
                           suffix={<img className='img-mini-small-8 cursor-pointer'
                                        style={{
                                            display: isStringNullOrEmpty(searchKey) ? "none" : "inherit",
                                            marginRight: '6px'
                                        }}
                                        onClick={() => {
                                            setSearchKey('');
                                            setArrayDatas(mArrayAllDatas);
                                        }}
                                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                           variant={"borderless"}
                           className={'input-border input-card-placeholder'}
                           style={{width: '320px', height: '32px'}}
                           placeholder={t("Search")} value={searchKey}
                           onChange={(event) => {
                               setSearchKey(event.currentTarget.value);
                               var arrayNewData = mArrayAllDatas.filter(p => p.name.toLowerCase().indexOf(event.currentTarget.value.toLowerCase()) >= 0);

                               setArrayDatas(arrayNewData);
                           }}/>

                    <div style={{flexGrow: '1'}}></div>

                    <div className='button-max-height button-solid-style flex-center font-size-12'
                         onClick={() => {
                             onEditTag(null);
                         }}
                         style={{marginLeft: '1px', height: '32px', borderRadius: '8px', minWidth: '105px'}}>
                        {/*<img className='img-mini-small-12' src={imgPathPerfix() + 'add_white.png'}/>*/}
                        <span className='ml-6'>{t("New tag")}</span>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    marginTop: '16px',
                    flexWrap: 'wrap',
                    marginLeft: '-6px',
                    marginRight: '-6px'
                }}>
                    {
                        arrayDatas.map(p => <Dropdown overlayClassName='default-dropdown-style'
                                                      menu={{items: menuItems, onClick: handleMenuClick}}
                                                      onOpenChange={(e)=>{
                                                          if (e) {
                                                              mSelectTag = p;
                                                          }
                                                      }}
                                                      trigger={['contextMenu']}>
                            <div style={{margin: '6px 6px'}} className={'flex-row-vertical-center tag hovered-gray-radius'}>
                                <span>#{p.name}</span>
                            </div>
                        </Dropdown>)
                    }
                </div>

                <DialogCommonInput ref={dialogInputRef}/>
            </div>
        </Modal>
    )
})

export default DialogAllTagManager;






















